import { __assign, __rest } from 'tslib';
import React, { forwardRef } from 'react';
import { ToastPlateDesktop } from '../../../toast-plate/esm/desktop';
import { BaseToast } from '../components/base-toast/component.js';
import 'react-merge-refs';
import 'react-transition-group';
import 'classnames';
import '../../../popover/esm';
import '../../../portal/esm';
import '../../../stack/esm';
import '@alfalab/hooks';
import '@alfalab/stack-context';

var DefaultToastPlateDesktop = forwardRef(function (props, ref) { return (React.createElement(ToastPlateDesktop, __assign({ ref: ref }, props))); });
var ToastDesktop = forwardRef(function (_a, ref) {
    var _b = _a.ToastPlate, ToastPlate = _b === void 0 ? DefaultToastPlateDesktop : _b, restProps = __rest(_a, ["ToastPlate"]);
    return (React.createElement(BaseToast, __assign({ ToastPlate: ToastPlate }, restProps, { ref: ref })));
});

export { ToastDesktop };
